import { render, staticRenderFns } from "./hotMajor.vue?vue&type=template&id=3cbca35f&scoped=true&"
import script from "./hotMajor.vue?vue&type=script&lang=js&"
export * from "./hotMajor.vue?vue&type=script&lang=js&"
import style0 from "./hotMajor.vue?vue&type=style&index=0&id=3cbca35f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbca35f",
  null
  
)

export default component.exports